import { jsx as o } from "react/jsx-runtime";
import { useMemo as g } from "react";
import L from "./styles.module.less.js";
import { MobileMenu as _ } from "./mobile.js";
import { DesktopMenu as f } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as D, canLanguageUseAtticus as I } from "../../../constants.js";
import { useScreenSize as h, WidthType as y } from "../../../utils/use-is-mobile.js";
const G = "FLOATING_CONTAINER_ID", R = "MENU_HEADER_ID", k = (M) => {
  const {
    isAuthenticated: t,
    openAuthModal: r,
    userImage: n,
    logout: i,
    hasNotifications: s,
    language: e = D,
    getTranslation: a,
    isLawyerSupported: u,
    useWill: m,
    lmpEnabled: c,
    onRequestLawyer: l,
    hideLinks: p,
    environment: d,
    lawyerView: A,
    legalHubSupported: E
  } = M, N = g(() => I(e) ? e : void 0, [e]);
  return h() === y.Mobile ? /* @__PURE__ */ o("div", { className: L.mobileMenuWrapper, children: /* @__PURE__ */ o(
    _,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: c,
      onRequestLawyer: N ? l : void 0,
      hideLinks: p,
      environment: d,
      lawyerView: A,
      legalHubSupported: E
    }
  ) }) : /* @__PURE__ */ o("div", { className: L.desktopMenuContainer, id: R, children: /* @__PURE__ */ o(
    f,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: c,
      onRequestLawyer: N ? l : void 0,
      hideLinks: p,
      environment: d,
      lawyerView: A,
      legalHubSupported: E
    }
  ) });
};
export {
  G as FLOATING_CONTAINER_ID,
  R as MENU_HEADER_ID,
  k as MenuComponent
};
